import { useState, useEffect } from 'react'
import { gql } from '@apollo/client'
import { Table, Alert } from 'reactstrap'
import Spinner from '../../Spinner/Spinner.js'
import '../Custom.css'
import { getData, getInputParams, currencyFormatter } from '../CustomUtils'
import { MEDICARE_REPORT_QUERY } from '../../../graphql.js'
import ColumnHeadings from '../ColumnHeadings.js'
import ParameterValues from '../ParameterValues.js'
import ReportGrid from '../ReportGrid.js'
import ReportTotalsRow from '../ReportTotalsRow.js'
import { getTenant } from '../../../utils.js'
import LargeRowHandler from '../LargeRowHandler.js'
import ReportHeading from '../ReportHeading.js'

const MEDICARE_REPORT = gql(MEDICARE_REPORT_QUERY)

export default function MedicareReport({ location }) {
  console.log('MedicareReport rendered:', location)

  const inputs = getInputParams(location)
  const [results, setResults] = useState()
  const [graphQLErrors, setGraphQLErrors] = useState([])

  useEffect(() => {
    getData(location, MEDICARE_REPORT, 'medicareReport', setResults, setGraphQLErrors)
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [location])

  if (graphQLErrors.length > 0) {
    return <Alert color="danger">{graphQLErrors[0].message}</Alert>
  } else if (!results) {
    return <Spinner />
  } else {
    const csvUrl = `${process.env.REACT_APP_SERVER}/csv/${getTenant()}/custom/Asbestos/medicareReport/medicare_report.csv?inputs=${JSON.stringify(inputs)}`
    const columnNumber = inputs['showPlaintiffCounsel'] ? 7 : 6
    const totalColumn = [{ columnNumber: columnNumber }]
    const columnFormatter = [{ columnNumber: columnNumber, formatter: currencyFormatter().format, align: 'right' }]
    return (
      <div className="custom-scroll">
        <div style={{ textAlign: 'center', margin: '10px 0px' }}>
          <LargeRowHandler csvUrl={csvUrl} resultsLength={results.reportData.length} />
        </div>
        <Table bordered style={{backgroundColor: 'white'}} >
          <ReportHeading title='Medicare Report' parameterValues={ParameterValues(results)} />
          <tbody>
            <ColumnHeadings results={results} />
            <ReportGrid results={results} columnFormatters={columnFormatter} />
            <ReportTotalsRow reportData={results.reportData} totalColumns={totalColumn} />
          </tbody>
        </Table>
      </div>
    )
  }
}